export default __webpack_public_path__ + "static/media/check-di-full.8273e97c.svg";